import { motion } from "framer-motion";
import { CalendarCheck, MessageSquareText, Wallet } from "lucide-react";
import { SectionHeading } from "./PriceMenu";
import { RevolutDepositButton, hasRevolutLink } from "./RevolutDepositButton";

const STEPS = [
  {
    id: "enquire",
    icon: MessageSquareText,
    title: "1. Send an Enquiry",
    note: "Tell us the occasion, date, size, flavour and any ideas. We reply with a quote and confirm availability.",
  },
  {
    id: "deposit",
    icon: CalendarCheck,
    title: "2. Confirm with a Deposit",
    note: "A 50% deposit secures your date. Pay by Revolut or card using the button below, or by bank transfer — details are sent with your quote.",
  },
  {
    id: "collect",
    icon: Wallet,
    title: "3. Pay the Balance & Collect",
    note: "The remaining balance is due before collection from Drogheda. Local delivery may be arranged on request.",
  },
];

export const PaymentLinks = () => (
  <section
    id="payment"
    data-testid="payment-section"
    className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32"
  >
    <SectionHeading
      eyebrow="Simple & Clear"
      title="How Ordering & Payment Works"
      testId="payment-heading"
    />

    <div className="mt-14 grid gap-8 md:grid-cols-3">
      {STEPS.map((p, i) => (
        <motion.div
          key={p.id}
          data-testid={`payment-step-${p.id}`}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: i * 0.12 }}
          className="flex flex-col rounded-sm border border-[#D4AF37]/20 bg-[#FFFFFF]/60 p-8 text-center backdrop-blur-xl transition-colors duration-500 hover:border-[#D4AF37]/50"
        >
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10">
            <p.icon size={22} className="text-[#D4AF37]" />
          </div>
          <h3 className="mt-6 font-display text-xl text-[#8A6D1F]">
            {p.title}
          </h3>
          <p className="mt-4 flex-1 text-sm leading-relaxed text-[#67718A]">
            {p.note}
          </p>
          {p.id === "deposit" && (
            <div className="mt-6 text-left">
              <RevolutDepositButton testId="payment-revolut-button" />
            </div>
          )}
        </motion.div>
      ))}
    </div>
    <p
      className="mt-8 text-center text-xs tracking-wide text-[#67718A]"
      data-testid="payment-note"
    >
      {hasRevolutLink()
        ? "Deposits are paid through Revolut's secure page — we never see your card details."
        : "Deposit payment details are sent with your quote."}
    </p>
  </section>
);
